import { Box } from '@mui/material';
import { User } from '../../../types/Users.types';
import { AdminsTableDesktop } from './AdminsTableDesktop';
import { AdminsTableMobile } from './AdminsTableMobile';

interface UsersTableProps {
  users?: User[];
  impersonationLock: boolean;
  onDeleteUser: (email: string) => void;
}

export const AdminsTable = ({
  users,
  impersonationLock,
  onDeleteUser,
}: UsersTableProps) => {
  return (
    <>
      <Box sx={{ display: { xs: 'none', md: 'block' }, mt: 24 }}>
        <AdminsTableDesktop
          users={users}
          impersonationLock={impersonationLock}
          onDeleteUser={onDeleteUser}
        />
      </Box>
      <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 24 }}>
        <AdminsTableMobile
          users={users}
          impersonationLock={impersonationLock}
          onDeleteUser={onDeleteUser}
        />
      </Box>
    </>
  );
};
